<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
        <b-row>
          <b-col cols="12">
            <b-breadcrumb :items="breadcrumbs" />
            <!-- Code added -->
            <b-card
              header-tag="header"
              footer-tag="footer"
              style=" margin-bottom: 0px;"
            >
              <label>Inspection Data : </label>
              <b-row class="boxto">
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-aqua">
                    <router-link :to="'/allocate_inspection/' + 'Approved'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="Approved Inspection List"
                        >
                          {{ resultData0.inspection_count }}
                        </h4>
                        <p
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData0.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-purpal">
                    <router-link :to="'/allocate_inspection/' + 'Pending'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData1.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData1.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-def">
                    <router-link :to="'/allocate_inspection/' + 'Scheduled'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData2.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData2.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-green">
                    <router-link :to="'/allocate_inspection/' + 'Hold'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData3.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData3.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-aqua">
                    <router-link :to="'/allocate_inspection/' + 'RFT'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData4.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData4.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-purpal">
                    <router-link :to="'/allocate_inspection/' + 'RC'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData5.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData5.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-purpal">
                    <router-link :to="'/allocate_inspection/' + '2nd Pass'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData6.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData6.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-def">
                    <router-link :to="'/allocate_inspection/' + 'Reject'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData7.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData7.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-green">
                    <router-link :to="'/allocate_inspection/' + 'Other'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData8.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData8.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-aqua">
                    <router-link :to="'/allocate_inspection/' + 'Cancel'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData9.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData9.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-def">
                    <router-link :to="'/allocate_inspection/' + 'Carry Forward'">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData10.inspection_count }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title=""
                        >
                          {{ resultData10.inspection_status }}
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- </b-card>
        </b-col>
      </b-row>
    </div> -->
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
const axios = require("axios");
export default {
  name: "dashboard",
  data: function() {
    return {
      name: "dashboard",
      id: "",
      Firstmile: [],
      Lasttmile: [],
      Reverse: [],
      a: -1,

      resultData0: [],
      resultData1: [],
      resultData2: [],
      resultData3: [],
      resultData4: [],
      resultData5: [],
      resultData6: [],
      resultData7: [],
      resultData8: [],
      resultData4: [],
      breadcrumb9: [
        {
          text: "Dashboard",
          active: true,
        },
      ],
    };
  },

  created: function() {
    this.displayDashboardData();
  },

  methods: {
    displayDashboardData: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.access_token = userInfo[0]["token"];
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";

      const Obj = {};

      axios
        .post(
          `${CONSTANTS.API_URL}/getDashboardCountOfAllBuyersForQCController`,
          Obj
        )
        .then((response) => {
          var result = response.data;
          console.log("Result", result);

          if (result.returnmsg === "Successful") {
            this.resultData0 = response.data.totalcount[0];
            this.resultData1 = response.data.totalcount[1];
            this.resultData2 = response.data.totalcount[2];
            this.resultData3 = response.data.totalcount[3];
            this.resultData4 = response.data.totalcount[4];
            this.resultData5 = response.data.totalcount[5];
            this.resultData6 = response.data.totalcount[6];
            this.resultData7 = response.data.totalcount[7];
            this.resultData8 = response.data.totalcount[8];
            this.resultData9 = response.data.totalcount[9];
            this.resultData10 = response.data.totalcount[10];
            console.log(this.resultData, " this.resultData this.resultData");
          }
        });
    },
  },
};
</script>

<style>
a:hover {
  color: #167495;
  text-decoration: none !important;
}
.bg-aqua {
  background-color: #00c0ef !important;
  color: #fff !important;
}
.bg-green {
  background-color: #00a65a !important;
  color: #fff !important;
}
.bg-yellow {
  background-color: #f39c12 !important;
  color: #fff !important;
}
.bg-pink {
  background-color: #ff69b4 !important;
  color: #fff !important;
}
.bg-purpal {
  background-color: #9370db !important;
  color: #fff !important;
}
.bg-cyan {
  background-color: #008b8b !important;
  color: #fff !important;
}
.bg-red {
  background-color: #dd4b39 !important;
  color: #fff !important;
}
.bg-def {
  background-color: #f09642 !important;
  color: #fff !important;
}
.boxto .card-body {
  padding: 0px !important;
}
.heading {
  padding: 12px 12px 5px 12px !important;
}
.countcolor {
  color: white !important;
}
.pointer {
  cursor: pointer !important;
}
</style>
